import { TableCell } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledTableCell = styled(TableCell)(() => ({
  fontWeight: 800,
})) as typeof TableCell;

export default StyledTableCell;
